package twist.mena.sports.shared.dto.admin

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class VerifyTokenResponse(
    val token: String,
    val email: String,
    val role: String,
    @SerialName("expires_at_utc") val expiresAtUtc: String
)
